/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef } from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip, FormControl } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { categorynewlist, salelist, roomslist, locationlist, upcomingReport } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';
import toast from 'shared/toast';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Upcoming.scss';
/**
 * this page is used to show sale item report in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="custom-drop-down"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));

export default class Upcoming extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            saletitle: { field: "saletitle", value: "", op: "=", join: "AND" },
            saleid: { field: "saleid", value: "", op: "=", join: "AND" },       
            sku: { field: "sku", value: "", op: "LIKE", join: "AND" },
            category: { field: "category", value: "", op: "=", join: "AND" },
            area: { field: "area", value: "", op: "=", join: "AND" },
            invoicenumber: { field: "invoicenumber", value: "", op: "LIKE", join: "AND" },
            shippable: { field: "shipping", value: "", op: "LIKE", join: "AND" },
            invoicestatus: { field: "invoicestatus", value: "", op: "=", join: "AND" },
            itemtype: { field: "itemtype", value: "", op: "=", join: "AND" },
            starttime: { field: 'endtime', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'endtime', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
            itemReadyCount: { field: 'itemReadyCount', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            category: [],
            sales: [],
            issearch: false,
            saleid: { value: '', valid: false, error: '' },
            locationid: { value: '', valid: false, error: '' },
            searchInput: null,
            showSearchBox: false,
            locations: [],
            isdisabled: false,
            location: '',
            locationlength:0,
            Selected_salename: '',
            isActiveCheckbox: false,
            isDateFromCheckBox: '',
            DateCheckBoXValue: '',
            isSalePendingCheckbox: false
        }

        this.config = {
            name: 'upcoming sales report',
            url: upcomingReport,
            isReport: true,
            params: {},
            columns: [

                { name: 'Location Name', property: 'locationtitle', sort: true, width: '200px',columnType: 'custom', customColumn: (row) => { if ('locationtitle' in row) return (row.locationtitle) } },
                { name: 'Location State', property: 'state', sort: true, width: '200px' },
                { name: 'Location Contact Name', property: 'locationcontactname', sort: true, width: '200px' },
                { name: 'Sale Title', property: 'saletitle', sort: true, width: '200px' },
                { name: 'CTBIDS Sale URL', property: 'saleviewurl', sort: false, width: '200px' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: "CSV", width: '200px',
                    actionEvents: {}, accordion: this.accordionValue
                }
            ],
            sort: [{
                "field": "starttime",
                "direction": "asc"
            }],
            pagination: true,
            filename: "upcoming-sales-report",
            field: ["locationtitle", "state", "locationcontactname", "saletitle", "saleviewurl", "starttime", "endtime","itemReadyCount","itemPendingCount", "timezonename",'timezoneid','timezoneshortcode','locationid','id'],
            csvColumn: [
                { name: 'Location Name', property: 'locationtitle' },
                { name: 'Location State', property: 'state' },
                { name: 'Location Contact Name', property: 'locationcontactname' },
                { name: 'Sale Title', property: 'saletitle', },
                { name: 'CTBIDS Sale URL', property: 'saleviewurl' },
                { name: 'Start Date/Time', property: 'starttime', columnType: 'custom', customColumn: this.customStartTime },
                { name: 'End Date/Time', property: 'endtime', columnType: 'custom', customColumn: this.customEndTime },
                { name: '# of Ready Items', property: 'itemReadyCount' },
                { name: '# of Pending Items', property: 'itemPendingCount' }
            ]    

        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.filterSearch = {};
        this.payments = [{ name: "Paid" }, { name: "UnPaid" }, { name: "Void" }]
        this.sales = [];
        this.areas = [];
        this.locations = [];
        this.oneDay = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.sevenDay = moment().add(6, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.forteenDay = moment().add(13, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.thirdyDay = moment().add(29, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
    }

    componentDidMount = () => {
        //this.getCategoryList();
        // this.getRoomsList();
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto my-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );

    checkBP = (value) => {
        const res = value.buyerspremium ? `${value.buyerspremium}` : "0";
        return res;
    }
    customAddress =(values) => {
        if (values.address2 != null){
            const res = values.address1 +' ,' + values.address2 ;
            return res;
        }
        else{
            const res = values.address1 ;
            return res;
        }
    }
    customItemUrl = (values) => {
        let itemurl = values["itemviewurl"];
        let hyperlink = "=HYPERLINK(\""+itemurl+"\"\")";
        return hyperlink;
    }
    /* Get room list */
    getRoomsList = () => {
        axios.get(getSellerUrl(roomslist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.areas = Object.keys(response.data.data)
                }
            })
            .catch(error => {
            });
    }

    // customAddQuotes = (values) => {
    //     return values.replace(/"/g, '""')
    // }

    customStartTime = (values) => {
        if (values['starttime'] != null) {
            let date = moment(values['starttime']);
            return `${date.format('MM/DD/YYYY hh:mm A')} ${moment.tz(values['timezonename']).zoneAbbr()}`;
        }
        else
            return '- - -';
    }
    customEndTime = (values) => {
        if (values['endtime'] != null) {
            let date = moment(values['endtime']);
            return `${date.format('MM/DD/YYYY hh:mm A')} ${moment.tz(values['timezonename']).zoneAbbr()}`;
        }
        else
            return '- - -';
    }
    customCloseTime = (values) => {
        if (values['closetime'] != null) {
            let newdate = moment.tz(values['closetime'], values['closetime']).local();
            return `${newdate.format('MM/DD/YYYY hh:mm:ss A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }
    

     // properly convert to boolean (Standard method)
     getBool(val) {
        try{
            if(val)
            return !!JSON.parse(String(val).toLowerCase());
            else
            return false
        }catch(e){
            return false
        }
    }

    dateFormat = (date) => {
        if (date) {
            let newdate = moment.tz(date, date).local();
        return `${newdate.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    }
    /* Get category list */
    getCategoryList = () => {
        axios.get(getSellerUrl(categorynewlist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    let category = response.data.data.data[0]
                    Object.values(category).map((item) => {
                        return item.sort()
                    })
                    this.setState({
                        ...this.state,
                        category,
                    });
                }
            })
            .catch(error => {
                toast.error(error.response.data['message']);
            });
    }
    /* Get sales list */
    getSaleList = () => {
        let filter = []
        if(!this.state.search.locationid.value) {
            filter = [
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }else {
            filter = [
                { field: 'locationid', value: this.state.search.locationid.value, op: '=', join: 'AND' },
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }
        let field = ["title","id"]
        var data = {
            "field": field,
            "filter": filter       
        };
        axios.post(getSellerUrl(salelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.sales = response.data.data;
                    const temp = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        ...this.state,
                        sales: temp,
                    });
                }
            })
            .catch(error => {
            });
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if(event.target.name === 'saleid'){
            eventValue=Number(eventValue)
        }
        if(event.target.name === 'locationid'){
        this.setState({
            ...this.state,
            issearch: true,
            isdisabled: true,
            Selected_salename: "",            
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: Number(eventValue)
                }
            }
        }, () => {
            this.getSaleList();
            if (event.target.value === '')
                this.checkSearch();
        });}
        else{
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }


    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            DateCheckBoXValue: '',
            isSalePendingCheckbox: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            // saletitle: { ...this.state.search.saletitle, },
            saleid: { ...this.state.search.saleid, value: this.state.search.saleid.value },
            sku: { ...this.state.search.sku, value: this.state.search.sku.value !== "" && `%${this.state.search.sku.value}%` },
            category: { ...this.state.search.category },
            area: { ...this.state.search.area, },
            invoicenumber: { ...this.state.search.invoicenumber, value: this.state.search.invoicenumber.value !== "" && `%${this.state.search.invoicenumber.value}%` },
            shippable: { ...this.state.search.shippable, value: this.state.search.shippable.value !== "" && `%${this.state.search.shippable.value}%` },
            invoicestatus: { ...this.state.search.invoicestatus },
            itemtype: { ...this.state.search.itemtype },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            locationid: { ...this.state.search.locationid, },
            itemReadyCount: { ...this.state.search.itemReadyCount, value: this.state.isSalePendingCheckbox ? 0 :  ""}
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }
    getTimeZone = () => {
        const timeZone = momentTz.tz.guess();
        return momentTz.tz(timeZone).zoneAbbr();
    }
    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr);
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div className="accordion-view" style={{ padding: "1% 1%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex">
                        <div>
                            {"locationtitle" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Location Name</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["locationtitle"]}</div>
                            </div>}
                            {"state" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Location State</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["state"]}</div>
                            </div>}
                            {"locationcontactname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Location Contact Name</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["locationcontactname"]}</div>
                            </div>}
                            {"saletitle" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sale Title</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["saletitle"]}</div>
                            </div>}
                            {"saleviewurl" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">CTBIDS Sale URL</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["saleviewurl"]}</div>
                            </div>}
                        </div>
                        <div style={{ marginLeft: '10%'}}>
                            {"starttime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sale Start Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['starttime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezonename']).zoneAbbr()}</div>
                            </div>}
                            {"endtime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sale End Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['endtime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezonename']).zoneAbbr()} </div>
                            </div>}
                            {"itemReadyCount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Ready Items</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["itemReadyCount"]}</div>
                            </div>}
                            {"itemPendingCount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Pending Items</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["itemPendingCount"]}</div>
                            </div>}
                        </div>
                    </div>
                    : ''}
            </div>
        );
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        });

    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            this.setState({
                showSearchBox: event,
                sales: [],
                searchInput: null,
            });
        }, event ? 500 : 100);
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            this.getSaleList();
        });
    }

    saleSelect = (sale) => {
        if (this.state.search.saletitle.value !== sale.title) {
            this.setState({
                searchInput: null,
                sales: [],
                Selected_salename: sale.title
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.searchInputChange(event);
            });
        }
    }

    onChangeCheckBox = (event,date) => {
        if(event === this.state.isActiveCheckbox){
            this.setState({
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
            },()=> {
                this.setState({
                    ...this.state,
                    search: {
                        ...this.state.search,
                        endtime: {
                            ...this.state.search['endtime'],
                            value: ''
                        },
                        starttime: {
                            ...this.state.search['starttime'],
                            value: moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")
                        },
                    }
                })
            })
        }
        else{
            if(event == "sale_pending_item"){
                this.setState({
                    isSalePendingCheckbox: !date
                })
            }else {
                this.setState({
                    isActiveCheckbox: event,
                    isDateFromCheckBox: true,
                    DateCheckBoXValue: date,
                },()=>{
                    this.setState({
                        ...this.state,
                        search: {
                            ...this.state.search,
                            endtime: {
                                ...this.state.search['endtime'],
                                value: date
                            },
                            starttime: {
                                ...this.state.search['starttime'],
                                value: moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")
                            },
                        }
                    })
                })  
            }    
        }
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
           .then(response => {
                this.locations = response[0].data.data;
                if(this.locations.length == '1'){                
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                            isdisabled:true,
                            search: {
                                ...this.state.search,
                                locationid: {
                                    ...this.state.search.locationid,
                                    value: this.locations[0].id
                                },
                            }
                        }, () => {
                            this.getSaleList();
                        });
                }
                else{
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                        })
                }
            })
            .catch(error => {
            });
    }
    render() {
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                        <option value="" disabled>Please select location</option>
                                            {this.state.locations.length > 1 ? <option value="All">All</option> : ''}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isSalePendingCheckbox ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('sale_pending_item',this.state.isSalePendingCheckbox)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Include sales with zero ready items</div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="mt-3">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="search-button" disabled={this.state.locationlength >'1'? !this.state.isdisabled: !this.state.isdisabled } onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                                <Row>
                                    <label style={{ marginLeft: '1%' }}>Sales closing in the next:</label>
                                </Row>
                                <Row style={{ marginTop: '-2%'}}>
                                    <Col md={2}>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'one_day' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('one_day',this.oneDay)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Today</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Today includes current date'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'seven_day' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('seven_day',this.sevenDay)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>7 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'7 days includes from current date'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '-2%'}}>
                                    <Col md={2}>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === '14_day' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('14_day',this.forteenDay)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>14 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'14 days includes from current date'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === '30_day' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('30_day',this.thirdyDay)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>30 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                                <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'30 days includes from current date'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}